// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8f1db923","674":"0201dbcd"}[chunkId] + ".chunk.js";
};